import { render, staticRenderFns } from "./BookingApiKeyEditView.vue?vue&type=template&id=b28ab36a"
import script from "./BookingApiKeyEditView.js?vue&type=script&lang=js&external"
export * from "./BookingApiKeyEditView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports